import { useEffect, useState } from "react";

import { CLICKING } from "..";
import UnitData from "./unitData";
import PowerRevenue from "./powerRevenue";
import RentalRevenue from "./rentalRevenue";
import OperatingExpenses from "./operatingExpenses";
import { getData, putData } from "../../../../../services";
import endPoints from "../../../../../services/apiEndPoints";
import { validateObject } from "../../../../../services/utils";
import { ONBOARDING_STATUES } from "../../../../../services/constants";
import { updateOnboardingStatus, VALIDATION_ERROR_MESSAGE } from "../../flows";

export const MAX_STEP_TENANCY = 3;

export const TenancyData = ({
  tenancyStep,
  building,
  onError,
  setUnitsFileUploaded,
  setLoading,
  clicking,
  handleNext,
  setClicking,
}) => {
  const StepComponent = [UnitData, RentalRevenue, OperatingExpenses, PowerRevenue][tenancyStep];

  const apiUrl = endPoints.OB_OPERATOR_TENANCY_DATA.replace("{id}", building.id);
  const [data, setData] = useState();
  let element = document.getElementById("bop-container");

  useEffect(() => {
    if (element) {
      element.scrollTo(0, 0);
    }
  }, [tenancyStep, element]);

  useEffect(() => {
    getData(apiUrl, setData)
      .catch(onError)
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (clicking === CLICKING.none) return;
    setLoading(true);
    putData(
      apiUrl,
      (data) => {
        if (clicking === CLICKING.next) {
          setClicking(CLICKING.none);
        }
        if (tenancyStep === MAX_STEP_TENANCY) {
          if (validateSavedData(data)) {
            updateOnboardingStatus(building.id, ONBOARDING_STATUES.completed);
          } else {
            onError(null, VALIDATION_ERROR_MESSAGE);
            return;
          }
        }
        handleNext();
      },
      data
    )
      .catch(onError)
      .finally(() => {
        setLoading(false);
        setClicking(CLICKING.none);
      });
  }, [clicking]);

  const validateSavedData = (data) => {
    return validateObject(data, [
      "potencial_rental_revenue",
      "total_potential_revenue",
      "total_termination_income",
      "total_late_fees",
      "total_parking_others",
      "other_revenues",
      "rental_revenues_growth",
      "property_taxes",
      "insurance",
      "repairs_maintenance",
      "property_management_fees",
      "advertisting",
      "payroll",
      "office_supplies",
      "phone_internet",
      "electricity",
      "gas",
      "other_utilites",
      "professional_services",
      "misc_expenses",
      "rental_expenses_growth",
      "fees",
      "management_fees",
      "debt_service",
    ]);
  };

  const onDataChange = (key, value) => {
    setData({ ...data, [key]: value });
  };

  return (
    <StepComponent
      building={building}
      onError={onError}
      data={data || {}}
      onDataChange={onDataChange}
      setUnitsFileUploaded={setUnitsFileUploaded}
    />
  );
};
